import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue';
import store from './Store';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAnalytics, {
  id: 'UA-135939226-1',
});

const leaflet = require('leaflet');

delete leaflet.Icon.Default.prototype._getIconUrl;

const iconRetinaUrl = require('leaflet/dist/images/marker-icon-2x.png');
const iconUrl = require('leaflet/dist/images/marker-icon.png');
const shadowUrl = require('leaflet/dist/images/marker-shadow.png');

leaflet.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl })

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
